module.exports = __webpack_public_path__ + "img/alta_pagoda_stainless.7cc273f9.png";